
import React from "react"
import { Button, Col, Empty, Row, Spin, Table } from "antd"
import AddSaleItemModal from "../AddSaleItemModal"
import { useSale } from "../../contexts/SaleContext"
import CreateBillModal from "../CreateBillModal"
import { useConfig } from "../../contexts/ConfigContext"
import { modules } from "../../config/const"
import { textNumberFormater } from "../../utils"

function RegisterView(props:any){
  const {sale} = useSale()
  const {config} = useConfig()
  return (
    <div className="container-fluid">
      <Spin size="large" tip="Procesando..." fullscreen spinning={props.spinning}  />
      {(config.isMobile || config.module === modules.RegisterSale) && <div style={{marginBottom:"1.5rem",alignItems:"center",justifyContent:"space-between",display:"flex"}}>
        <h1 className="title-content">{props.title}</h1>
      </div>}   
      <div className="card shadow" style={{marginBottom:"1.5rem"}}>
        <div className="card-header" style={{paddingTop:"1rem"}}>
          <h6 className="font-weight-bold text-primary" style={{margin:0}}>Datos de registro</h6>
        </div>
        <div className="card-body">
          <Table 
            rowClassName={"no-padding-rows"} 
            columns={props.columnsData} 
            dataSource={props.itemList}
            onRow={props.onRow}
            size="small"
            pagination={false}
            scroll={{x:"max-content"}}
            locale={{emptyText:<Empty description="Sin registros, agregue el primero"></Empty>}}
            footer={props.footerElement}></Table>
        </div>
      </div>
      <div
        style={{
          position: "sticky",
          bottom: 0,
          background: "#fff",
          padding: "16px",
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
          zIndex: 10,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          borderRadius: "8px 8px 0 0",
        }}
      >
        <Row gutter={[10, 10]}>
          <Col>
            <Button type="primary" onClick={()=>props.addPending(true)}>Facturar</Button>
          </Col>
          <Col>
            <Button type="default" onClick={()=>props.addPending(false)}>Guardar</Button>
          </Col>
        </Row>
        {props.subTotal !== undefined && (
          <div
            className="card shadow-sm"
            style={{
              padding: "0.6rem 1.25rem",
              borderRadius: "8px",
              backgroundColor: "#fff",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
              border: "1px solid #e2e8f0"
            }}
          >
            <span style={{ fontSize: "1.05rem", fontWeight: 500, color: "#4a5568" }}>Subtotal:</span>
            <span className="numeric-values-data-table" style={{ fontSize: "1.3rem", fontWeight: "bold", color: "#1890ff" }}>
              {textNumberFormater(props.subTotal)}
            </span>
          </div>
        )}
      </div>
      {sale.showAddItem && <AddSaleItemModal />} 
      {sale.showBill && <CreateBillModal />} 

    </div>
  )
}

export default RegisterView